// system.js

//获取医院列表url
export const getHospitalListAPIUrl = '/api/workflow/hooks/NjgxMDhjZTliYWJhOWQyZTdhZDQ0NDlh'
//获取字典列表url
export const getDictionaryListUrl = 'api/v1/open/app/getOptionSets'

export const getQRCodeUrl = '/api/workflow/hooks/NjgxYWNiMzFiYWJhOWQyZTdhZTYxMWI3'

//user.js

//验证人员信息
export const verifyUserUrl = '/api/workflow/hooks/NjgxMDhjZTliYWJhOWQyZTdhZDQ0NDk0'
//添加预约挂号订单
export const addAppointmentBookingUrl = '/api/workflow/hooks/NjgxMDhjZTliYWJhOWQyZTdhZDQ0NDk1'
//添加陪诊订单
export const addMedicalAccompanyUrl = '/api/workflow/hooks/NjgxMDhjZTliYWJhOWQyZTdhZDQ0NDk2'
//添加入院订单
export const admissionBookingUrl = '/api/workflow/hooks/NjgxMDhjZTliYWJhOWQyZTdhZDQ0NDk3'
//添加手术预约
export const surgicalBookingUrl = '/api/workflow/hooks/NjgxMDhjZTliYWJhOWQyZTdhZDQ0NDk4'
//特约检查
export const specialCheckUrl = '/api/workflow/hooks/NjgxMDhjZTliYWJhOWQyZTdhZDQ0NDk5'
//查询预约订单
export const getOrderListUrl = '/api/workflow/hooks/NjgxMDhjZTliYWJhOWQyZTdhZDQ0NDli'
